import Emitter from "es6-event-emitter";
import albSlide from "./../../templates/albSlide.dust";
import AlbImageSlider from "./albImageSlider";
import language from "./../../dictionary";
import { stripHtml } from "./../../utilities/utils";
import spinner from "./../../templates/spinner.dust";
// eslint-disable-next-line
import enrichmentButton from "./../../templates/enrichmentButton.dust"; // this is needed!

export default class AlbSlide extends Emitter {
  appState = null;
  slide = null;

  contentID = null;

  slideNumber = null;
  pageNumber = null;
  articleNumber = null;

  content = null;
  options = null;
  loaderDOMContainer = null;

  constructor(
    appState,
    content,
    slideNumber,
    pageNumber,
    articleNumber,
    options
  ) {
    super();
    this.appState = appState;
    this.content = content;
    this.options = options;

    this.slideNumber = slideNumber;
    this.pageNumber = pageNumber;
    this.articleNumber = articleNumber;

    this.contentID = this.content.ContentID;
  }

  hasExtras() {
    return this.content.contentItemContent().extras.length > 0;
  }

  getNumberOfExtras() {
    return this.content.contentItemContent().extras.length;
  }

  getExtraType() {
    return this.content.contentItemContent().extraType;
  }

  getSharingLink() {
    if (this.content.contentItemContent().sharing) {
      return stripHtml(this.content.contentItemContent().sharing.Title);
    }
    return null;
  }

  getTitle() {
    if (this.content.contentItemContent().article) {
      return stripHtml(this.content.contentItemContent().article.Title);
    }
    return null;
  }

  getIntro() {
    if (this.content.contentItemContent().article) {
      return stripHtml(this.content.contentItemContent().article.Introduction);
    }
    return null;
  }

  createContext() {
    const context = this.content.contentItemContent();
    context.slideN = this.slideNumber;
    context.pageN = this.pageNumber;
    context.articleN = this.articleNumber;
    context.id = this.content.ContentID;
    context.fixedImgHeight = this.options.fixedImgHeight;
    context.maxLines = this.options.captionMaxLines;
    context.displayPageCategory = this.options.displayPageCategory;
    context.urlTitle = language.alsoRead;
    context.videoTitle = language.alsoWatch;
    context.imageTitle = language.alsoSee;

    context.desktop = this.appState.isDesktop;

    if (this.hasExtras()) {
      //`TODO: Use new downloader to load extra images`
      context.extra = true;
      context.numberExtras = this.getNumberOfExtras();
      context.extraTitle = language.Extra;
      context.extraButton = this.options.extraButtonOnEachPage;
      context.extraButtonTitle = this.options.extraButtonInTitle;
      context.extraType = this.getExtraType();

      context.extras.sort((firstItem, secondItem) => {
        return firstItem.ContentItemPosition - secondItem.ContentItemPosition;
      });
    }

    if (this.content.contentItemContent().images.length > 0) {
      context.imageSlider = true;
      if (this.content.contentItemContent().images.length === 1) {
        context.singleImage = true;
      } else {
        context.images.sort((firstItem, secondItem) => {
          return firstItem.ContentItemPosition - secondItem.ContentItemPosition;
        });
      }
    }
    return context;
  }

  render() {
    this.slide = document.createElement("div");
    this.slide.classList.add("swiper-slide");
    this.slide.classList.add("alb-slide");
    this.slide.setAttribute("data-slideN", this.slideNumber);
    this.slide.setAttribute("data-pageN", this.pageNumber);
    this.slide.setAttribute("data-articleN", this.articleNumber);
    this.slide.setAttribute("data-contentID", this.content.ContentID);

    const promise = new Promise((resolve) => {
      const context = this.createContext();
      Dust.render(albSlide, context, (err, result) => {
        // use jquery!! if innerHTML is used tags aren't properly closed if client provided cirreupt htmltext
        $(this.slide).html(result);
        if (context.imageSlider) {
          this.createImageSlider(context);
        }
        this.attatchClickHandlers(context.extraImageViewer);
        resolve(this.slide);
      });
    });
    return promise;
  }

  createImageSlider(context) {
    this.imageSlider = new AlbImageSlider(
      this.appState,
      this.slide.querySelector(".alb-image-slider-container"),
      context,
      this.options
    );
    this.imageSlider.render();
  }

  onAddedToAlb() {
    if (this.imageSlider) {
      this.imageSlider.onAddedToAlb();
    }
  }

  update() {
    if (this.imageSlider) {
      this.imageSlider.update();
    }
  }

  attatchClickHandlers(context) {
    if (this.hasExtras()) {
      this.extrasContainer = this.slide.querySelector(".alb-article-extras");
      if (this.options.hideExtraButtonWhenInExtras) {
        const scroll = this.slide.querySelector(".alb-content-scroll");
        if (scroll) {
          scroll.addEventListener("scroll", () => {
            this.onScroll();
          });
        }
      }
      if (this.options.extraButtonOnEachPage) {
        const button = this.slide.querySelector(".alb-extra-button-container");
        this.buttonContainer = button;
        if (button) {
          button.addEventListener("click", () => {
            this.scrollExtrasInView();
          });
        }
      }
      const link = this.slide.querySelector("a.alb-extra-ad");
      if (link) {
        link.addEventListener("click", (event) => {
          const urlWithConsentParams =
            this.appState.analyticsManager.checkEnrichmentUrl(
              event.currentTarget.attributes.href.value
            );
          if (urlWithConsentParams) {
            window.open(urlWithConsentParams, "_blank");
          } else {
            window.open(event.currentTarget.attributes.href.value, "_blank");
          }
        });
      }
    }

    $(this.slide)
      .find(".alb-extra-image")
      .on("click", (e) => {
        this.openImageViewer(e, context);
      });

    const grab = this.slide.querySelector(".alb-content-scroll");
    const alb = document.querySelector("#alb");
    if (grab) {
      let pushed;
      let lastClientY;
      grab.addEventListener("mousedown", (e) => {
        pushed = 1;
        lastClientY = e.clientY;
        grab.style.cursor = "grabbing";
      });
      alb.addEventListener("mouseup", () => {
        pushed = 0;
        grab.style.cursor = "grab";
      });
      grab.addEventListener("mousemove", (e) => {
        if (pushed) {
          let scroller = grab.scroller || grab;
          const newScrollY = -lastClientY + (lastClientY = e.clientY);
          scroller.scrollTop -= newScrollY;
        }
      });
    }
  }

  openImageViewer(e, context) {
    const slide = Number(e.currentTarget.getAttribute("data-id"));
    if (this.appState.isDesktop) {
      this.renderEnrichmentLoader(
        e.currentTarget.closest(".alb-article-extras-item-content")
      );
      const ImageGallery = require("./../imageGallery").default;
      new ImageGallery({
        appState: this.appState,
        slideNumber: slide + 1,
        context,
        options: this.options.imageviewer,
        loopSwiper: true,
        loadedCallback: () => {
          document
            .querySelector(
              ".swiper-slide-active .alb-article-extras-item-content.loading"
            )
            .classList.remove("loading");
        },
      });
    } else {
      const ImageGalleryMobile =
        require("./../../../touch/reader/components/imageGallery/imageGalleryMobile").default;
      new ImageGalleryMobile({
        appState: this.appState,
        slideNumber: slide,
        context,
        options: this.options.imageviewer,
      });
    }
  }

  scrollExtrasInView() {
    if (this.extrasContainer) {
      const scroll = this.slide.querySelector(".alb-content-scroll");
      const cont = this.slide.querySelector(".alb-content");
      this.extrasContainer.scrollIntoView();
      if (scroll && cont) {
        const x = $(this.extrasContainer).height() + scroll.scrollTop;
        if (x > $(cont).height()) {
          scroll.scrollTop -= this.options.marginScrollExtraInView;
        }
      }
    }
  }

  extrasInView() {
    if (this.extrasContainer && this.slide) {
      const rect = this.extrasContainer.getBoundingClientRect();
      const view = this.slide.getBoundingClientRect();

      if (rect.top < view.height + this.options.extrasInViewMargin) {
        return true;
      }
    }
    return false;
  }

  hideExtraButton() {
    if (this.buttonContainer) {
      this.buttonContainer.classList.add("hidden");
    } else {
      this.trigger("albSlide:hideExtraButton");
    }
  }

  showExtraButton() {
    if (this.buttonContainer) {
      this.buttonContainer.classList.remove("hidden");
    } else {
      this.trigger("albSlide:showExtraButton");
    }
  }

  onScroll() {
    //TODO: if button on swiper and not on slide
    if (!this.options.hideExtraButtonWhenInExtras) {
      return;
    }
    if (this.hasExtras()) {
      if (this.extrasInView()) {
        this.hideExtraButton();
      } else {
        this.showExtraButton();
      }
    }
  }

  renderEnrichmentLoader(imageContainer) {
    this.loaderDOMContainer = imageContainer.querySelector(
      ".alb-extra-image-viewer-loader"
    );
    if (this.loaderDOMContainer && !this.loaderDOMContainer.hasChildNodes()) {
      Dust.render(spinner, {}, (err, result) => {
        this.loaderDOMContainer.innerHTML = result;
        imageContainer.classList.add("loading");
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/articleLightbox/albSlide.js